import BaseApiService from './BaseApiService.js';

class ClassService extends BaseApiService {
  // ✅ Create a new class
  async createClass(classData) {
    return this.makeRequest('/api/class/create', {
      method: 'POST',
      body: JSON.stringify(classData),
    });
  }

  // ✅ Get all classes
  async getAllClasses() {
    return this.makeRequest('/api/class/all');
  }

  // ✅ Get classes by organization
  async getClassesByOrg(orgId) {
    if (!orgId) {
      console.warn('⚠️ OrgId is null or undefined, cannot fetch classes');
      return [];
    }
    // Try to convert to number if it's numeric, otherwise use as-is (for string codes like "SCH002")
    const finalOrgId = /^\d+$/.test(orgId) ? parseInt(orgId, 10) : orgId;
    return this.makeRequest(`/api/class/org/${finalOrgId}`);
  }

  // ✅ Get active classes by organization
  async getActiveClassesByOrg(orgId) {
    if (!orgId) {
      console.warn('⚠️ OrgId is null or undefined, cannot fetch active classes');
      return [];
    }
    // Try to convert to number if it's numeric, otherwise use as-is (for string codes like "SCH002")
    const finalOrgId = /^\d+$/.test(orgId) ? parseInt(orgId, 10) : orgId;
    return this.makeRequest(`/api/class/org/${finalOrgId}/active`);
  }

  // ✅ Get class by ID
  async getClassById(classId) {
    return this.makeRequest(`/api/class/${classId}`);
  }

  // ✅ Update class
  async updateClass(classId, classData) {
    return this.makeRequest(`/api/class/update/${classId}`, {
      method: 'PUT',
      body: JSON.stringify(classData),
    });
  }

  // ✅ Delete class
  async deleteClass(classId) {
    return this.makeRequest(`/api/class/delete/${classId}`, {
      method: 'DELETE',
    });
  }

  // ✅ Deactivate class
  async deactivateClass(classId) {
    return this.makeRequest(`/api/class/${classId}/deactivate`, {
      method: 'PUT',
    });
  }

  // ✅ Activate class
  async activateClass(classId) {
    return this.makeRequest(`/api/class/${classId}/activate`, {
      method: 'PUT',
    });
  }

  // ✅ Search classes by name
  async searchClassesByName(className) {
    return this.makeRequest(`/api/class/search?className=${encodeURIComponent(className)}`);
  }

  // ✅ Get class count for organization
  async getClassCount(orgId) {
    if (!orgId) return 0;
    const finalOrgId = /^\d+$/.test(orgId) ? parseInt(orgId, 10) : orgId;
    return this.makeRequest(`/api/class/org/${finalOrgId}/count`);
  }

  // ✅ Get classes by grade level
  async getClassesByGrade(grade) {
    return this.makeRequest(`/api/class/grade/${grade}`);
  }

  // ✅ Get inactive classes
  async getInactiveClassesByOrg(orgId) {
    if (!orgId) return [];
    const finalOrgId = /^\d+$/.test(orgId) ? parseInt(orgId, 10) : orgId;
    return this.makeRequest(`/api/class/org/${finalOrgId}/inactive`);
  }
}

// ✅ Export single instance
const classService = new ClassService();
export default classService;
